import React from 'react';
import {
  arrayOf,
  shape,
  string,
  number,
} from 'prop-types';
import { Heading } from 'components/common';
import SectionInfoColumn from './SectionInfoColumn';

import './EligibilitySection.scss';

const EligibilitySection = ({
  eligibilityCriteria = [],
  labels: {
    heading,
    toggleLabels,
    showMoreThreshold,
  },
}) => (
  <div className="eligibility-section">
    <div className="container-wrapper">
      <div className="row-wrapper">
        <div className="title">
          <Heading as="h2">
            {heading}
          </Heading>
        </div>
        <div className="content">
          <div className="row-wrapper">
            {eligibilityCriteria && eligibilityCriteria.length > 0 && (
              <div className="info-column-wrapper">
                <SectionInfoColumn
                  title={heading}
                  titleHiddenOnDesktop
                  infoItems={eligibilityCriteria}
                  toggleLabels={toggleLabels}
                  showMoreThreshold={showMoreThreshold}
                />
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  </div>
);

EligibilitySection.defaultProps = {
  eligibilityCriteria: [],
  labels: {},
};

EligibilitySection.propTypes = {
  eligibilityCriteria: arrayOf(
    shape({
      name: string,
      value: string,
    })
  ),
  labels: shape({
    heading: string,
    toggleLabels: shape({
      showMore: string,
      showLess: string,
    }),
    showMoreThreshold: number,
  }),
};

export default EligibilitySection;
